import { useCallback } from 'preact/hooks';
import type { Currency } from '../../shared/types';
import { fmtCurrency, fmtSignedCurrency } from '../../shared/format';
import { usePrivacy } from './contexts';

const SYMBOL: Record<Currency, string> = { USD: '$', EUR: '€' };
const DOTS = '•••';

type AmountOpts = { signed?: boolean; decimals?: number };

export function useMask() {
  const { hidden } = usePrivacy();

  const amount = useCallback(
    (value: number, ccy: Currency, opts: AmountOpts = {}): string => {
      if (!hidden) {
        return opts.signed
          ? fmtSignedCurrency(value, ccy, { decimals: opts.decimals })
          : fmtCurrency(value, ccy, { decimals: opts.decimals });
      }
      const sym = SYMBOL[ccy];
      if (opts.signed) {
        if (value === 0) return `${sym}0`;
        const sign = value > 0 ? '+' : '−';
        return `${sign}${sym}${DOTS}`;
      }
      return value < 0 ? `−${sym}${DOTS}` : `${sym}${DOTS}`;
    },
    [hidden]
  );

  const quantity = useCallback(
    (value: number): string => {
      if (!hidden) {
        return Number.isInteger(value)
          ? value.toLocaleString('en-US')
          : value.toLocaleString('en-US', { maximumFractionDigits: 4 });
      }
      return DOTS;
    },
    [hidden]
  );

  return { amount, quantity, hidden };
}
